const config = {
  mainTitle: 'Party Additions',
  subHeading: 'A page to see Party Additional Items. (Note: Price is *100 here)',
  titleIcon: 'IosBookmarksOutline'
}

export default config;
